<template>
    <transition
        v-on:enter="enterTransition"
        v-on:leave="leaveTransition"
        v-bind:css="false"
    >
        <div v-show="isExpanded()">
            <slot></slot>
        </div>
    </transition>
</template>
<script>
import Velocity from 'velocity'

export default {
    name: 'oc-collapse',
    model: {
        prop: 'visible',
        event: 'input'
    },
    props: {
        id: {
            type: String,
            required: true
        },
        visible: {
            type: Boolean,
            default: undefined
        }
    },
    watch: {
        visible: {
            immediate: true,
            handler() {
                this.updateStatus()
            }
        }
    },
    created() {
        this.$root.$on('oc::collapse', ($event, target, operation) => {
            if( target !== this.id ) {
                return
            }

            this[operation]() // toggle/close/open
        })
    },
    data() {
        return {
            status: this.visible === undefined ? true : false
        }
    },
    methods: {
        open() {
            if( this.status === true ) {
                return
            }

            this.$emit('before-open')

            this.status = true
            this.emitState()

            this.$emit('after-open')
        },
        close() {
            if( this.status === false ) {
                return
            }

            this.$emit('before-close')

            this.status = false
            this.emitState()

            this.$emit('after-close')
        },
        toggle() {
            this.$emit('before-toggle')

            this.status = ! this.status
            this.emitState()

            this.$emit('after-toggle')
        },
        //////////////////////////////
        isExpanded() {
            return this.status
        },
        emitState() {
            this.$emit('input', this.status)
        },
        updateStatus() {
            if( this.visible !== undefined ) {
                this.status = this.visible
            }
        },
        enterTransition (el, done) {
            Velocity(el, "slideDown", { duration: 350, complete: () => {
                done()
                this.$emit('after-open-complete')
            }, easing: 'ease-in-out' })
        },
        leaveTransition (el, done) {
            Velocity(el, "slideUp", { duration: 350, complete: () => {
                done()
                this.$emit('after-close-complete')
            }, easing: 'ease-in-out' })
        }
    }
}
</script>
